<template>
    <div style="display: flex;">
        <div v-for="(column, index) in columns" style="margin: 0 10px">
            <el-statistic :value="displayValues[column.key]" >
                <template #title>
                    <div style="display: inline-flex; align-items: center">
                    <span>{{ column.label }}</span>
                    </div>
                </template>
                <template v-if="widgets.options?.suffix" #suffix>{{ widgets.options.suffix }}</template>
            </el-statistic>
        </div>
    </div>
</template>
<script>
import { chartColumnLabel, resolveChartDisplayRow } from '../display'

export default{
    props: ["widgets", "data", "additional", "fieldMeta"],
    data(){
         return{
         }
    },
    computed: {
        values(){
            if(this.data.length > 0){
                return this.data[0];
            }else{
                return {};
            }
        },
        displayValues(){
            return resolveChartDisplayRow(this.values, this.fieldMeta, this.additional);
        },
        columns(){
            const columns = [];
            this.widgets.dimensions.forEach((dimension) => {
                columns.push({
                    label: chartColumnLabel(dimension),
                    key: dimension.Name,
                });
            });
            this.widgets.measures.forEach((measure) => {
                columns.push({
                    label: chartColumnLabel(measure),
                    key: measure.Name,
                });
            });
            return columns;
        }
    },
    mounted(){

    }
}
</script>
